var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-nav-container"},[_c('div',{staticClass:"header-close"},[_c('i',{staticClass:"iconfont icon-close",on:{"click":_vm.closeMenu}})]),_c('div',{staticClass:"header-top"},[_c('Logo')],1),_c('div',{staticClass:"header-bottom"},[_c('HeaderLink')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }